import avatarUserDefault from '@/assets/images/avatar-user-default.png'

const usersListTable = {
  columns: {
    getColumnsData: 'usersListColumnsData',
    setColumnsData: 'setUsersListColumnsData'
  },
  rows: {
    getRowsData: 'usersList',
    setRowsData: 'setUsersList'
  }
}

const usersListTableTableColumns = [
  {
    id: 0,
    property: 'image',
    type: 'img',
    defaultImg: avatarUserDefault
  },
  {
    id: 1,
    title: 'NAME',
    property: 'username'
  },
  {
    id: 2,
    title: 'POSITION',
    property: 'position.name'
  },
  {
    id: 3,
    title: 'ROLE',
    property: 'role'
  },
  {
    id: 4,
    title: 'EMAIL',
    property: 'email'
  },
  {
    id: 5,
    property: 'action',
    actions: {
      edit: '',
      delete: ''
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false
    }
  }
]

export {usersListTable, usersListTableTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/usersListTable.js